import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';

/**
 * Wrapper hook around {@link useSearchParams} that provides convenience methods
 */
export const useQueryParams = (): {
  queryParams: URLSearchParams;
  setQueryParams: ReactSetURLSearchParams;
  setQueryParam: (key: string, value: string) => void;
  deleteQueryParam: (key: string, shouldReplace?: boolean) => void;
} => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQueryParam = useCallback(
    (key: string, value: string) => {
      setSearchParams((currentSearchParams) => {
        currentSearchParams.set(key, value);
        return currentSearchParams;
      });
    },
    [setSearchParams]
  );
  const deleteQueryParam = useCallback(
    (key: string, shouldReplace?: boolean) => {
      setSearchParams(
        (currentSearchParams) => {
          currentSearchParams.delete(key);
          return currentSearchParams;
        },
        shouldReplace ? {replace: shouldReplace} : undefined
      );
    },
    [setSearchParams]
  );

  return {
    queryParams: searchParams,
    setQueryParams: setSearchParams,
    setQueryParam,
    deleteQueryParam,
  };
};

type ReactSetURLSearchParams = ReturnType<typeof useSearchParams>[1];
